module.exports = __webpack_public_path__ + "img/phone_img.bf504ff4.png";